// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5e6cbd6","239":"6cc54f36","453":"2b538381","455":"1a4bfefc","762":"7b20c9e2"}[chunkId] + ".chunk.js";
};